import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onBeforeMount, ref, watch } from 'vue';
import { reportIndexPvUvAndTimeCost, language } from '@tencent/ppd-base-libs';
import { handleSetWxShareInfo, setUpWeixinInit } from '@/business';
import { storeToRefs } from 'pinia';
import { useConfigStore, useDpStore, useLocationStore } from '@/store';
import { reportLoadConfigTiming } from './utils/report-loadconfig-timing';
import { wxBridge } from '@tencent/wphk-base-wx';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isReady = ref(false);

// store
const configStore = useConfigStore();
const { currentAreaWxShareConf } = storeToRefs(configStore);
const { getCurrentWujiConfig } = configStore;

const { currentArea } = storeToRefs(useLocationStore());

const { initDp } = useDpStore();

// 初始化页面
async function initPageData() {
  await Promise.all([getCurrentWujiConfig(), initDp()]);
  isReady.value = true;
  // 设置微信分享
  handleSetWxShareInfo(currentAreaWxShareConf.value);
  reportLoadConfigTiming();
}

// 切换地区，更新数据
watch(currentArea, async () => {
  if (currentArea.value) {
    isReady.value = false;
    // 初始化页面
    initPageData();
  }
});

onBeforeMount(async () => {
  // 初始化微信
  await setUpWeixinInit();
  // 初始化页面
  initPageData();
  wxBridge.disableBounceScroll().catch((err) => {
    console.error(err);
  });
  wxBridge.hideMenuCopyUrl();
});

onMounted(() => {
  reportIndexPvUvAndTimeCost();
});

return { __sfc: true,isReady, configStore, currentAreaWxShareConf, getCurrentWujiConfig, currentArea, initDp, initPageData, language }
}

})